import { oc } from '@orpc/contract';
import { reorderKpisInputSchema, reorderKpisOutputSchema } from '../schemas/kpis.schemas.js';
export const reorderKpisContract = oc
    .route({
    method: 'POST',
    path: '/kpis/reorder',
    tags: ['KPIs'],
    summary: 'Rewrite one pillar’s display order as a dense 1..N sequence (ADMIN, PM)',
})
    .input(reorderKpisInputSchema)
    .output(reorderKpisOutputSchema);
//# sourceMappingURL=reorder-kpis.contract.js.map